import { render, staticRenderFns } from "./SubventionsabrechnungErstellenModal.vue?vue&type=template&id=2d5a9d55"
import script from "./SubventionsabrechnungErstellenModal.vue?vue&type=script&lang=js"
export * from "./SubventionsabrechnungErstellenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports